module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Regular.128e425.woff2";